import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";

export const useInsuranceStatusHistory = (insuranceId, enabled = true) =>
  useQuery({
    queryKey: ["insurance-status-history", insuranceId],
    queryFn: () =>
      axios
        .get(`${API_URL}/insurance/${insuranceId}/status-history`)
        .then((r) => r.data?.data ?? []),
    enabled: Boolean(enabled) && !!insuranceId,
    refetchOnWindowFocus: false,
  });

export const addInsuranceStatusEntry = (insuranceId, payload) =>
  axios.post(`${API_URL}/insurance/${insuranceId}/status-history`, payload);
